/**
 * @file app.js
 * @description Application constants: list of hosted apps and available modules
 */

/**
 * List of external/internal applications available in the ecosystem.
 * Each entry contains a friendly name, a constant value and the target URL.
 * @type {{name: string, value: string, url: string}[]}
 */
export const APPS = [
    { name: "Dispatch", value: "DISPATCH", url: "https://dispatch.rhombuss.ee" },
    { name: "Driver", value: "DRIVER", url: "https://beta.rhomtrip.com" },
    { name: "Internal", value: "INTERNAL", url: "https://beta-internal.rhomtrip.com" },
    { name: "Partners", value: "PARTNERS", url: "https://beta-partners.rhomtrip.com" },
    { name: "Suppliers", value: "SUPPLIERS", url: "https://beta-suppliers.rhomtrip.com/" },
    { name: "Web", value: "WEB", url: "https://beta.rhomtrip.com" }
];

/**
 * Modules available in the internal application. Each module has a display name,
 * a constant value (used for routing/permissions) and an icon class for UI.
 * @type {{name: string, value: string, icon: string}[]}
 */
export const MODULES = [
    {
        name: "Account",
        value: "ACCOUNT",
        icon: "flaticon-profile"
    },
    {
        name: "Areas",
        value: "AREAS",
        icon: "flaticon-radar"
    },
    {
        name: "Customers",
        value: "CUSTOMERS",
        icon: "flaticon-employees"
    },
    {
        name: "Dashboard",
        value: "DASHBOARD",
        icon: "flaticon-trend"
    },
    {
        name: "Destinations",
        value: "DESTINATIONS",
        icon: "flaticon-pin"
    },
    {
        name: "Documentation",
        value: "DOCUMENTATION",
        icon: "flaticon-tools-application"
    },
    {
        name: "Experiences",
        value: "EXPERIENCES",
        icon: "flaticon-package"
    },
    {
        name: "Global",
        value: "GLOBAL",
        icon: "flaticon-global"
    },
    {
        name: "Logs",
        value: "LOGS",
        icon: "flaticon-history-1"
    },

    {
        name: "Partners",
        value: "PARTNERS",
        icon: "flaticon-support"
    },
    {
        name: "Profile",
        value: "PROFILE",
        icon: "flaticon-profile"
    },
    {
        name: "Rates",
        value: "RATES",
        icon: "flaticon-bold-list"
    },
    {
        name: "Reservations",
        value: "RESERVATIONS",
        icon: "flaticon-calendar"
    },
    {
        name: "Suppliers",
        value: "SUPPLIERS",
        icon: "flaticon-businessman-1"
    },
    {
        name: "Team",
        value: "TEAM",
        icon: "flaticon-costumer"
    },
    {
        name: "Vehicles",
        value: "VEHICLES",
        icon: "flaticon-car"
    },
    {
        name: "Vehicles Gallery",
        value: "VEHICLES_GALLERY",
        icon: "flaticon-tools-image-gallery"
    },
    {
        name: "Agents",
        value: "AGENTS",
        icon: "flaticon-support"
    }
];

